export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10301.1d8bf4e7.jpg";